/*
  Minimal GA4 integration using gtag.js. Controlled via
  REACT_APP_GA_MEASUREMENT_ID (build-time) or window.GA_MEASUREMENT_ID (runtime).
*/

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    GA_MEASUREMENT_ID?: string;
  }
}

function injectGtag(): void {
  if (document.getElementById('gtag-js')) return;
  const s = document.createElement('script');
  s.async = true;
  s.id = 'gtag-js';
  // URL finalized once initialized with a measurement ID by initGA
  document.head.appendChild(s);
}

export function initGA(measurementId: string): void {
  if (!measurementId) return;
  // Ensure script tag exists with correct src
  let script = document.getElementById('gtag-js') as HTMLScriptElement | null;
  if (!script) {
    script = document.createElement('script');
    script.async = true;
    script.id = 'gtag-js';
    document.head.appendChild(script);
  }
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag as any;
  window.gtag('js', new Date());
  window.gtag('config', measurementId);
}

export function trackPageView(path: string): void {
  if (!window.gtag) return;
  try {
    window.gtag('event', 'page_view', {
      page_path: path,
    });
  } catch {
    // ignore
  }
}

export function trackEvent(action: string, params?: Record<string, any>): void {
  if (!window.gtag) return;
  try {
    window.gtag('event', action, params || {});
  } catch {
    // ignore
  }
}

